__webpack_require__.p = "/rickandmortywiki/";